import { __makeTemplateObject } from '../../../../_virtual/_tslib.js';
import styled, { css } from 'styled-components';
import { focusVisible } from '../../shared/global.styles.js';
var quantityButton = css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  cursor: pointer;\n  &:disabled {\n    background-color: ", ";\n    opacity: 0.5;\n    cursor: default;\n  }\n\n  &:hover {\n    background-color: ", ";\n  }\n\n  &:active {\n    background-color: ", ";\n  }\n"], ["\n  cursor: pointer;\n  &:disabled {\n    background-color: ", ";\n    opacity: 0.5;\n    cursor: default;\n  }\n\n  &:hover {\n    background-color: ", ";\n  }\n\n  &:active {\n    background-color: ", ";\n  }\n"])), function (props) {
  var _a;

  return (_a = props.theme.palette) === null || _a === void 0 ? void 0 : _a.lighter;
}, function (props) {
  var _a;

  return (_a = props.theme.palette) === null || _a === void 0 ? void 0 : _a.lightest;
}, function (props) {
  var _a;

  return (_a = props.theme.palette) === null || _a === void 0 ? void 0 : _a.lighter;
});
var border = css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  border: 1px solid ", ";\n"], ["\n  border: 1px solid ", ";\n"])), function (props) {
  var _a;

  return (_a = props.theme.palette) === null || _a === void 0 ? void 0 : _a.disabledGray;
});
var borderRadiusLeft = css(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  border-top-left-radius: ", "px;\n  border-bottom-left-radius: ", "px;\n  border-right: none;\n"], ["\n  border-top-left-radius: ", "px;\n  border-bottom-left-radius: ", "px;\n  border-right: none;\n"])), function (props) {
  var _a;

  return (_a = props.theme.attributes) === null || _a === void 0 ? void 0 : _a.borderRadius.small;
}, function (props) {
  var _a;

  return (_a = props.theme.attributes) === null || _a === void 0 ? void 0 : _a.borderRadius.small;
});
var borderRadiusRight = css(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  border-top-right-radius: ", "px;\n  border-bottom-right-radius: ", "px;\n  border-left: none;\n"], ["\n  border-top-right-radius: ", "px;\n  border-bottom-right-radius: ", "px;\n  border-left: none;\n"])), function (props) {
  var _a;

  return (_a = props.theme.attributes) === null || _a === void 0 ? void 0 : _a.borderRadius.small;
}, function (props) {
  var _a;

  return (_a = props.theme.attributes) === null || _a === void 0 ? void 0 : _a.borderRadius.small;
});
var QuantitySelectorContainer = styled.div(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n  display: grid;\n  grid-template-columns: 40px 48px 40px;\n  height: 40px;\n  background: ", ";\n  width: 128px;\n\n  @media (min-width: ", "px) {\n    grid-template-columns: 32px 40px 32px;\n    width: 104px;\n    height: 32px;\n  }\n"], ["\n  display: grid;\n  grid-template-columns: 40px 48px 40px;\n  height: 40px;\n  background: ", ";\n  width: 128px;\n\n  @media (min-width: ", "px) {\n    grid-template-columns: 32px 40px 32px;\n    width: 104px;\n    height: 32px;\n  }\n"])), function (props) {
  var _a;

  return (_a = props.theme.palette) === null || _a === void 0 ? void 0 : _a.transparent;
}, function (props) {
  var _a;

  return (_a = props.theme.breakpoints) === null || _a === void 0 ? void 0 : _a.sm;
});
var QuantityButton = styled.button(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background-color: ", ";\n  ", "\n  ", "\n  ", "\n"], ["\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background-color: ", ";\n  ", "\n  ", "\n  ", "\n"])), function (props) {
  var _a;

  return (_a = props.theme.palette) === null || _a === void 0 ? void 0 : _a.white;
}, quantityButton, border, function (props) {
  return props.direction === 'left' ? borderRadiusLeft : borderRadiusRight;
});
var QuantityInput = styled.input(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n  ", "\n  z-index: 1;\n  text-align: center;\n  border-radius: 0;\n  &::-webkit-outer-spin-button,\n  &::-webkit-inner-spin-button {\n    -webkit-appearance: none;\n    margin: 0;\n  }\n  &:focus-visible {\n    border: 1px solid ", ";\n  }\n  outline: none;\n  ", "\n"], ["\n  ", "\n  z-index: 1;\n  text-align: center;\n  border-radius: 0;\n  &::-webkit-outer-spin-button,\n  &::-webkit-inner-spin-button {\n    -webkit-appearance: none;\n    margin: 0;\n  }\n  &:focus-visible {\n    border: 1px solid ", ";\n  }\n  outline: none;\n  ", "\n"])), border, function (props) {
  var _a;

  return (_a = props.theme.palette) === null || _a === void 0 ? void 0 : _a.alertBlue;
}, function (props) {
  return !props.customFocus && focusVisible;
});
var IconContainer = styled.div(templateObject_8 || (templateObject_8 = __makeTemplateObject(["\n  display: grid;\n  place-content: center;\n"], ["\n  display: grid;\n  place-content: center;\n"])));
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8;
export { IconContainer, QuantityButton, QuantityInput, QuantitySelectorContainer };